import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import StepContainer from './StepContainer';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Button from 'components/buttons/Button';
import PriceField from 'components/CustomInputs/PriceField';

import FormValidationContent from 'constants/FormValidationContent';
import Preference from 'containers/Preference';
import { CircularProgress } from '@material-ui/core';
import { findFieldByFieldKey } from 'utils';
import Preapproval from 'containers/Preapproval';

const content = {
	en: {
		title: 'How much is your monthly income?',
		incomeInfo: 'Nett income.',
		next: 'Next',
		previous: 'Previous',
		somethingWentWrong: 'Something went wrong. Please try again later.'
	},
	id: {
		title: 'Berapa jumlah pendapatan bulanan Anda?',
		incomeInfo: 'Pendapatan bersih.',
		next: 'Lanjut',
		previous: 'Kembali',
		somethingWentWrong: 'Terjadi kesalahan. Silakan coba lagi nanti.'
	}
};

const propTypes = {
	showToast: PropTypes.func,
	toNextPage: PropTypes.func,
	toPrevPage: PropTypes.func,
	validationSchema: PropTypes.object
};

const MonthlyIncome = props => {
	const { toNextPage, toPrevPage, validationSchema, showToast } = props;

	const { state: { languageCode } } = Preference.useContainer();
	const translation = languageCode === 'en' ? content.en : content.id;
	const validationTranslation = languageCode === 'en' ? FormValidationContent.en : FormValidationContent.id;

	const {
		state: {
			form, fields, fieldsUpsert
		},
		upsertFields,
		resetFieldsUpsert
	} = Preapproval.useContainer();

	const { register, handleSubmit, setValue, watch, errors, clearErrors } = useForm({
		resolver: yupResolver(validationSchema)
	});

	const monthlyIncome = watch('monthly_income');

	useEffect(() => {
		const monthlyIncome = findFieldByFieldKey(fields, 'monthlyIncome')?.fieldValue;
		register({ name: 'monthly_income' });
		setValue('monthly_income', monthlyIncome);
	}, []);

	useEffect(() => {
		if (fieldsUpsert.success) {
			resetFieldsUpsert();
			toNextPage();
		} else if (fieldsUpsert.error) {
			resetFieldsUpsert();
			showToast(translation.somethingWentWrong);
		}
	}, [fieldsUpsert]);

	const onSubmit = data => {
		upsertFields(form.id, [{
			fieldKey: 'monthlyIncome',
			fieldValue: String(data.monthly_income)
		}]);
	};

	const handlePrev = () => {
		toPrevPage();
	};

	return (
		<div className="monthly-income-preapproval">
			<div className="title">{translation.title}</div>
			<form onSubmit={handleSubmit(onSubmit)}>
				<PriceField
					decimalSeparator={false}
					error={errors.monthly_income ? true : false}
					message={validationTranslation[errors.monthly_income?.message] || translation.incomeInfo}
					onValueChange={value => {
						setValue('monthly_income', value.value);
						if (value.value) clearErrors('monthly_income');
						else setValue('monthly_income', undefined);
					}}
					thousandSeparator={'.'}
					value={monthlyIncome}
				/>
				<div className="buttons">
					<Button onClick={handlePrev} type="button" variant="outlined">
						{translation.previous}
					</Button>
					<Button disabled={fieldsUpsert.loading || !monthlyIncome || monthlyIncome < 1}
						type="submit"
						variant="contained"
					>
						{fieldsUpsert.loading? (
							<CircularProgress />
						) : (
							translation.next
						)}
					</Button>
				</div>
			</form>
		</div>
	);
};

MonthlyIncome.propTypes = propTypes;
export default StepContainer(MonthlyIncome);
